import { Controller } from '@hotwired/stimulus'
import TurboClient from '../api/TurboClient'

export default class extends Controller {
  static targets = ['form', 'button', 'stripeCardIdInput']

  initialize() {
    this.formTarget.addEventListener('submit', event => {
      event.preventDefault()
      this.onSubmit()
    })

    this.formTarget.addEventListener('keypress', event => {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.onSubmit()
      }
    })
  }

  async onSubmit() {
    // Custom button without form
    const buttonElement = this.buttonTarget
    const originalButtonElementText = buttonElement.textContent
    buttonElement.textContent = buttonElement.dataset.disableWith
    buttonElement.disabled = true

    if (this.hasStripeCardIdInputTarget) {
      const selectedCardId = this.getCheckedRadioValue('credit-card')
      this.stripeCardIdInputTarget.value = selectedCardId || ''
    }

    const resetButton = () => {
      buttonElement.textContent = originalButtonElementText
      buttonElement.disabled = false
    }

    try {
      const turboClient = new TurboClient(this.formTarget)
      const turboClientResponse = await turboClient.perform()

      // A successful order redirects to confirmation — no redirect means it didn't go through, re-enable for retry
      if (!turboClientResponse.response?.redirected) resetButton()
    } catch (error) {
      console.error('Payment submission error:', error)
      const detail = error?.message ? ` (${error.message})` : ''
      toastr.error(`Oops, something went wrong. Please try again or contact customer support.${detail}`)
      resetButton()
    }
  }

  getCheckedRadioValue(inputName) {
    const radios = Array.from(document.getElementsByName(inputName))
    const checkedValue = radios.find(radio => radio.checked)?.value

    return checkedValue
  }
}
